/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import React, { useState } from 'react';

import SegmentedButton from 'components/Form/Inputs/SegmentedButton';
import BoxRadioGroup from 'components/Form/Inputs/BoxRadioGroup';

import SecureAccountMethodIcon from 'components/SecureAccountMethodIcon';

import HeaderText, { HeaderTextVariants } from 'components/HeaderText';
import t from 'tcomb-validation';

import useIsMobile from 'hooks/browser/useIsMobile';

import { TwoStepSetupFormCard } from 'containers/Settings/TwoStepVerification';
import { SecurityQuestionFormCard } from 'containers/Settings/SecurityQuestionsForm';
import TwoFactorEmail from './TwoFactorEmailSetup';


function OptionButton({ option }) {
  return (
    <div style={{
      textAlign: 'center'
    }}>
      <div style={{ padding: '20px 0px 10px 0px' }}>
        <SecureAccountMethodIcon method={option.value}
          size={26}
          color="primaryBlue" />
      </div>
      {option?.text}
    </div>
  );
}

function getOptionContent(key, onComplete) {
  switch (key) {
    case 'SmsCode': return <TwoStepSetupFormCard
      showDisableButton={false}
      autoFocus={true}
      onComplete={onComplete}
    />;
    case 'EmailCode': return <TwoFactorEmail onComplete={onComplete} />;
    case 'SecurityQuestions': return <SecurityQuestionFormCard onComplete={onComplete} />;
    default: return null;
  }
}

function getOptionLabel(key) {
  switch (key) {
    case 'SmsCode': return 'Text/SMS Code';
    case 'EmailCode': return 'Email Code';
    case 'SecurityQuestions': return 'Security Questions';
    default: return null;
  }
}


const SecureAccountOptions = ({
  secureAccountMethods,
  onComplete
}) => {
  const [selected, setSelected] = useState();
  const isMobile = useIsMobile();

  // available options
  let optionEnum = {};
  secureAccountMethods?.forEach((m) => {
    optionEnum[m] = getOptionLabel(m);
  });

  // selected option
  let optionKey = null;
  if (secureAccountMethods?.length === 1) {
    // auto select when only 1 option
    optionKey = secureAccountMethods[0];
  } else {
    optionKey = selected;
  }

  return (
    <div>
      <div style={{ paddingBottom: 24 }}>
        <HeaderText>
          Secure Your Account
        </HeaderText>
        <HeaderText variant={HeaderTextVariants.Small} style={{ paddingTop: '14px', paddingBottom: '20px' }}>
          Keep your account safe by enabling two-factor authentication.
        </HeaderText>
      </div>

      {secureAccountMethods?.length > 1
        ? (
          <div>
            <div style={{ lineHeight: '24px' }}>
              How would you like to secure your account?
            </div>
            {isMobile
              ? (
                <SegmentedButton
                  value={selected}
                  onChange={v => setSelected(v)}
                  type={t.enums(optionEnum)} />
              )
              : (
                <BoxRadioGroup
                  type={t.enums(optionEnum)}
                  renderRadioButton={o => <OptionButton option={o} />}
                  value={selected}
                  onChange={v => setSelected(v)} />
              )}
          </div>
        )
        : null}

      <div style={{ margin: '30px 0px' }}>
        {getOptionContent(optionKey, onComplete)}
      </div>

    </div>
  );
};

export default SecureAccountOptions;